// How a remembered account looks: its initials, its colour and the short
// line that names how it last signed in. Pure, so the apps' version can
// copy it as it is.

// Eight colours, each at least 4.5:1 against white initials, chosen by the
// email so an account keeps its colour on every visit (never stored).
export const AVATAR_COLOURS = ['#1F5F99', '#6B3FA0', '#A3305A', '#A94418', '#2E7D32', '#00796B', '#8A5A00', '#455A64']

// FNV-1a over the lower-cased email.
export const emailHash = email => {
  const value = String(email || '').trim().toLowerCase()
  let hash = 0x811c9dc5
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193) >>> 0
  }
  return hash >>> 0
}

export const avatarColour = email => AVATAR_COLOURS[emailHash(email) % AVATAR_COLOURS.length]

const firstLetter = word => {
  const letters = Array.from(word || '')
  return letters.length ? letters[0].toUpperCase() : ''
}

// "Ada Lovelace" -> "AL"; "Ada" -> "A"; no name: the email's local part
// ("ada.lovelace@..." -> "AL", "ada@..." -> "A").
export const initialsOf = ({ name, email } = {}) => {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (words.length) return (firstLetter(words[0]) + (words.length > 1 ? firstLetter(words[words.length - 1]) : '')) || '?'

  const local = String(email || '').trim().split('@')[0]
  const parts = local.split(/[._\-+]+/).filter(Boolean)
  if (!parts.length) return '?'
  return firstLetter(parts[0]) + (parts.length > 1 ? firstLetter(parts[1]) : '')
}

export const domainOfEmail = email => {
  const value = String(email || '').trim()
  const at = value.lastIndexOf('@')
  return at > 0 && at < value.length - 1 ? value.slice(at + 1).toLowerCase() : ''
}

// The last method in a few words: "Password", "Another device", or the
// connection's label -- "EdXR Azure Dev", or "Single sign-on" without one.
// No domain: the email is on the line above. null when nothing is known.
export const methodHint = account => {
  const method = account && account.method
  if (!method) return null

  switch (method.kind) {
    case 'password':
      return 'Password'
    case 'device':
      return 'Another device'
    case 'sso': {
      return (method.connection && method.connection.displayName) || 'Single sign-on'
    }
    default:
      return null
  }
}
